import { array } from 'prop-types';
import React, {
    Fragment,
    useCallback,
    useRef,
    useState,
    useEffect,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { searchFacetChange } from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';

const FacetedSearchGroup = ({ group }) => {
    const list = useRef(null);
    const [isActive, setIsActive] = useState(false);

    const compareOptions = (a, b) => {
        const extractNumberBeforeDash = (id) => {
            const match = id.match(/^\d+/);
            return match ? parseInt(match[0], 10) : Infinity;
        };

        const aNumber = extractNumberBeforeDash(a.id);
        const bNumber = extractNumberBeforeDash(b.id);

        if (aNumber !== bNumber) {
            return aNumber - bNumber;
        } else {
            return a.label.localeCompare(b.label);
        }
    };

    const sortedOptions = group.options.slice().sort(compareOptions);

    return (
        <Fragment>
            <div className="accordion">
                <div className="accordion-item">
                    <ul
                        className="faceted-search__group"
                        role="group"
                        ref={list}
                    >
                        <div className="faceted-search__group-header">
                            <div
                                className="accordion-title"
                                onClick={() => setIsActive(!isActive)}
                            >
                                <div>{group.label}</div>
                                <div>
                                    {isActive ? (
                                        <span className="accordion--arrow__down"></span>
                                    ) : (
                                        <span className="accordion--arrow__up"></span>
                                    )}
                                </div>
                            </div>
                            {sortedOptions.map((item, itemIndex) => (
                                <li
                                    key={`${item.label}-${itemIndex}`}
                                    className="faceted-search__item"
                                    role="menuitemcheckbox"
                                >
                                    {isActive && (
                                        <FacetedFilterCheckbox
                                            item={item}
                                            group={group}
                                        />
                                    )}
                                </li>
                            ))}
                        </div>
                    </ul>
                </div>
            </div>
        </Fragment>
    );
};

const FacetedFilterCheckbox = ({ item, group }) => {
    const dispatch = useDispatch();
    const onChange = useCallback(
        (group, item) => dispatch(searchFacetChange(group, item)),
        [dispatch]
    );
    return (
        <label className="faceted-filter">
            <input
                className="faceted-filter__input"
                type="checkbox"
                onChange={(event) => onChange(group, item)}
                checked={
                    group.selectedOptions != null &&
                    group.selectedOptions.includes(item.id)
                }
            />
            <span className="faceted-filter__label">
                {item.label}
                {!isNaN(item.quantity) && item.quantity != null && (
                    <span className="faceted-filter__quantity">
                        &nbsp;({item.quantity})
                    </span>
                )}
            </span>
        </label>
    );
};

const FacetedSearch = () => {
    const dispatch = useDispatch();
    const filterBox = useRef(null);
    const { facetFilters, navigationTheme } = useSelector(
        (state) => state.facetedSearch
    );
    const clickHandler = useCallback((event) => {
        if (filterBox.current &&
            !filterBox.current.contains(event.target) &&
            !event.target.classList.contains('faceted-search-title') &&
            filterBox.current.classList.contains('faceted-search-group--show')
        ) {
            toggleFilter();
        }
    }, []);

    const toggleFilter = () => {
        filterBox.current.classList.toggle('faceted-search-group--show');
    };
    useEffect(() => {
        window.addEventListener('mousedown', clickHandler);
        return () => window.removeEventListener('mousedown', clickHandler);
    }, [clickHandler]);
    return (
        navigationTheme !== 'category' &&
        facetFilters &&
        facetFilters.length > 0 && (
            <div className="faceted-search" role="menu">
                {facetFilters && facetFilters.length > 0 && (
                    <h3
                        onClick={() => toggleFilter()}
                        className="faceted-search-title"
                    >
                        {' '}
                        {translate('facet.header.filter')}
                    </h3>
                )}
                <div ref={filterBox} className="faceted-search-group">
                    {facetFilters.map((group, groupIndex) => (
                        <FacetedSearchGroup
                            key={`${group.label}-${groupIndex}`}
                            group={group}
                        />
                    ))}
                </div>
            </div>
        )
    );
};

export default FacetedSearch;
